import React from "react";
import "./style.css";
import Logo from "../Logo";

const Footer = () => {
  return (
    <footer>
      <p>
        We're a team of Professional cooks who are excited about their food,
        amazing skills and expertiness in cooking.
      </p>
      <Logo />
    </footer>
  );
};

export default Footer;
